import { useEffect } from 'react';
import useAuth from '../../hooks/useAuth';

const Login = () => {
  const auth = useAuth();

  // Call `auth.signin()` once the page is loaded
  useEffect(() => {
    auth.signin();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `auth` should not be passed into the dependencies array
  }, []);

  return <div>Loading...</div>;
};

export default Login;
